import {
  breakpoints,
  getSemanticColor,
  SemanticColorKey,
  theme,
} from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledDivider = styled.div<{
  shouldShowOnMobile?: boolean;
  color?: SemanticColorKey;
}>`
  display: ${({ shouldShowOnMobile = true }) =>
    shouldShowOnMobile ? 'block' : 'none'};
  height: 0.0625rem;
  background-color: ${({ color }) =>
    color ? getSemanticColor(color) : theme.color.background.disabled};

  @media (min-width: ${breakpoints.lg}) {
    display: block;
    position: relative;
    clear: both;
    margin: 3rem 0 0;
  }
`;
